import { render, staticRenderFns } from "./PrevNextAuction.vue?vue&type=template&id=1539be94&"
import script from "./PrevNextAuction.vue?vue&type=script&lang=js&"
export * from "./PrevNextAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports